export default __webpack_public_path__ + "static/media/icon-heart-cycle.9f677874.svg";